module.exports = __webpack_public_path__ + "img/page-footer-bg.174fcfe5.png";